import { createAction } from "@reduxjs/toolkit";
import { ExportReportingState } from "types/export-reporting";

export const setAppliedTemplate = createAction<ExportReportingState["appliedTemplate"]>(
  "bulkUpdate/appliedTemplate",
);

export const setLoadingSplash = createAction<ExportReportingState["loadingSplash"]>(
  "bulkUpdate/loadingSplash",
);
